import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/app/layouts/home.vue").then(m => m.default || m))
}